import React from 'react'
import { Route } from 'react-router-dom'
import { IProtectedRoute } from './index'

export interface IProtectedRouteFull extends IProtectedRoute {
  canViewPage: boolean
}

export const ProtectedRoute = ({
  component: Component,
  canViewPage,
  ...rest
}: IProtectedRouteFull) => {
  const ProtectedComponent = () => canViewPage
    ? <Component />
    : <h1>You are not authorized to view this page</h1>

  return <Route {...rest} render={ProtectedComponent} />
}
